import React from "react";
import Menu from "./Menu";
import MenuItem from "./MenuItem";
import { ArrowIcon } from "../icons";
import useReportLanguage from "../hooks/useReportLanguage";
import { ReportLanguage } from "../service/ReportLanguageService";

const ReportLanguageSelect = () => {
  const [language, setLanguage] = useReportLanguage();

  const element = (
    <div
      className="flex items-center h-[30px] px-2 rounded-lg text-[12px] font-semibold text-[#303030] hover:cursor-pointer hover:bg-[#EEEDE8]"
      title="Jezik izveštaja"
    >
      {language}
      <ArrowIcon className="ml-2" width={12} transform={"rotate(180)"} />
    </div>
  );

  return (
    <Menu element={element} position="right">
      <div className="px-[14px] pt-[10px] pb-1 text-[11px] text-[#1f1f1f99] whitespace-nowrap">
        Jezik izveštaja
      </div>
      {Object.values(ReportLanguage).map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => setLanguage(option.value)}
          endIcon={option.value === language ? <span className="ml-3">✓</span> : null}
        >
          <span className="whitespace-nowrap">
            {option.value} · {option.label}
          </span>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ReportLanguageSelect;
